import AsyncStorage from "@react-native-async-storage/async-storage";
import { Fragment, useEffect, useState } from "react";
import {
  ActivityIndicator,
  Image,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { useTranslation } from "react-i18next";
import { AppBar, EmptyState } from "../components";
import SurveyCard from "../components/Survey/SurveyCard";
import { getSurveys } from "../services/survey";
import { EditIcon } from "../assets/icons";
import { checkRespondentEligible } from "../services/screening";
import i18n from "../translation/index";
import md5 from "md5";
import { getProgramId } from "../services/programs";
import SurveyKarakterCard from "../components/Survey/SurveyKarakterCard";

const SurveyPage = ({ route }) => {
  const { params } = route;
  const { t } = useTranslation();
  const [survey, setSurvey] = useState([]);
  const [memberId, setMemberId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [role, setRole] = useState("");
  const [isQuick, setIsQuick] = useState(false);
  const [refId, setRefId] = useState(undefined);
  const [program, setProgram] = useState({});
  const [answerIds, setAnswerIds] = useState([]);
  const [mode, setMode] = useState(t("survey:menu-all"));
  const [newPracticeExists, setNewPracticeExists] = useState(false);
  const [lang, setLang] = useState("id");

  useEffect(() => {
    if (params.isQuick) {
      AsyncStorage.setItem("token", md5("quick"));
      setIsQuick(true);
    }

    if (!params.isQuick) {
      AsyncStorage.setItem("answerId", "");
    }

    async function getMember() {
      let theRefId = await AsyncStorage.getItem("refId");
      if (!theRefId) {
        theRefId = md5(new Date().getTime());
        AsyncStorage.setItem("refId", theRefId);
      }
      setRefId(theRefId);

      const memberId = await AsyncStorage.getItem("token");
      setMemberId(memberId);

      const theAnswerIds = await AsyncStorage.getItem("answerId");
      setAnswerIds(theAnswerIds);

      return memberId;
    }

    setTimeout(() => {
      getMember();
    }, 1000);
  }, []);

  useEffect(() => {
    if (!memberId || !refId) {
      return;
    }

    if (params.isQuick && !memberId) {
      AsyncStorage.setItem("token", md5("quick"));
      setIsQuick(true);
      setMemberId(md5("quick"));
    }

    getProgramId(params.additionalContentId)
      .then((res) => {
        setProgram(res.data[0]);
      })

    getSurveys(params?.additionalContentId, memberId, (params?.isScreening === "1" ? "1" : "0") + (params.isQuick ? `?ref_id=${refId}` : ''))
      .then((res) => {
        const surveyData = res.data;

        if (surveyData.find(s => s.isNewPractice === 1)) {
          setNewPracticeExists(true);
        }
        
        setSurvey(surveyData);
      })
      .finally(() => setIsLoading(false));
  }, [memberId, params, params?.refresh, refId]);

  useEffect(() => {
    async function getLang() {
      return await AsyncStorage.getItem("lang");
    }

    getLang()
      .then((res) => {
        if (!res) {
          AsyncStorage.setItem("lang", "id");
          i18n.changeLanguage("id");
          setMode(t("survey:menu-all"))
          setLang("id")
          return;
        }
        AsyncStorage.setItem("lang", res);
        i18n.changeLanguage(res);
        setMode(t("survey:menu-all"))
        setLang(res)
      });
  }, []);

  return (
    <Fragment>
      <AppBar
        title={isQuick ? "Program" : "Survey"}
        isBack={params?.backButton}
      />
      {isLoading && (
        <View
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#EEEAFF",
          }}
        >
          <ActivityIndicator color="#6724E2" />
        </View>
      )}
      {isQuick && !isLoading && (
        <View style={styles.headerBox}>
          <Image
            source={{
              uri: `https://media.fammi.ly/uploads/products/images/${program?.productImage}?v=${new Date().getTime()}`,
            }}
            style={styles.image}
          />
          <Text style={styles.title}>{program.productName}</Text>
          {program.productDescription && (
            <Text style={styles.desc}>
              {program.productDescription}
            </Text>
          )}
        </View>)
      }
      {
        !isLoading &&
        newPracticeExists &&
        <View style={{
          padding: 16,
          backgroundColor: "#EEEAFF",
          display: "flex",
          flexDirection: "row",
          gap: 12,
          justifyContent: 'flex-start',
          alignItems: "center",
        }}>
          {
            [t("survey:menu-all"), t("survey:menu-assessment"), t("survey:menu-report")].map((i) => {
              return <View style={{
                paddingVertical: 10,
                paddingHorizontal: 12,
                borderRadius: 10,
                backgroundColor: mode === i ? "#6724E2" : "#FFF",
              }}
                onClick={() => {
                  setMode(i);
                }}
              >
                <Text style={{
                  fontFamily: "Archivo-Medium",
                  fontSize: 10,
                  textTransform: "capitalize",
                  color: mode === i ? "#FFF" : "#000",
                }}>{i}</Text>
              </View>;
            })
          }
        </View>
      }
      {/* { 
        !isLoading &&
        survey?.length > 0 &&
        (mode === "semua" || mode == "asesmen") &&
      } */}
      {
        !isLoading &&
        survey?.length > 0 &&
        (
          <ScrollView
            style={{
              flex: 1,
              padding: 16,
              backgroundColor: "#EEEAFF",
              gap: 16,
            }}
          >
            <SurveyKarakterCard
              data={survey[0] || {}}
              additionalContentId={params?.additionalContentId}
              isScreening={params?.isScreening}
              role={role}
              isQuick={isQuick}
              answerIds={answerIds}
              lang={lang ?? "id"}
            />
            {
              survey.map((item) => {
                if ((mode === t("survey:menu-report") || mode === t("survey:menu-all")) && (item.isNewPractice === 1)) {
                  return <SurveyCard
                    key={item.quizId}
                    data={item}
                    additionalContentId={params?.additionalContentId}
                    isScreening={params?.isScreening}
                    role={role}
                    isQuick={isQuick}
                    answerIds={answerIds}
                    lang={lang ?? "id"}
                  />;
                }
                if ((mode === t("survey:menu-assessment") || mode === t("survey:menu-all")) && (item.isNewPractice !== 1 || !item.isNewPractice)) {
                  return <SurveyCard
                    key={item.quizId}
                    data={item}
                    additionalContentId={params?.additionalContentId}
                    isScreening={params?.isScreening}
                    role={role}
                    isQuick={isQuick}
                    answerIds={answerIds}
                    lang={lang ?? "id"}
                  />;
                }
              })
            }
            <View style={{ height: 16 }}>
              <Text>
                &nbsp;
              </Text>
            </View>
          </ScrollView>
        )}
      {
        !isLoading &&
        survey?.length === 0 &&
        <ScrollView contentContainerStyle={styles.container}>
          <EmptyState
            Icon={EditIcon}
            title={"Kamu Belum Punya " + (params?.isScreening === "1" ? "Screening" : "Survey")}
            desc={"Saat ini belum ada " + (params?.isScreening === "1" ? "screening" : "survey") + " diberikan di dalam program"}
          />
        </ScrollView>

      }
    </Fragment>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    backgroundColor: "#EEEAFF",
  },
  headerBox: {
    backgroundColor: "#fff",
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 10,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  },
  image: {
    width: "100%",
    height: 61,
    borderRadius: 10,
    resizeMode: "cover",
  },
  title: {
    fontFamily: "Archivo-SemiBold",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 15,
    marginTop: 16,
    marginBottom: 10,
  },
  desc: {
    fontFamily: "Archivo-Regular",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: 13,
    lineHeight: 16,
  },
});

export default SurveyPage;
